(() => {
  const header = document.querySelector(".gs-header");
  const toggle = document.querySelector(".gs-nav-toggle");
  const nav = document.querySelector(".gs-nav");

  const menuUi = window.grainsmartTheme?.ui || {};
  const openMenuLabel = menuUi.openMenu || "Open menu";
  const closeMenuLabel = menuUi.closeMenu || "Close menu";

  const closeMenu = () => {
    document.body.classList.remove("gs-menu-open");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", openMenuLabel);
    }
  };

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = document.body.classList.toggle("gs-menu-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? closeMenuLabel : openMenuLabel);
    });

    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMenu);
    });
  }

  if (header) {
    const onScroll = () => {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  const initLanguageSwitchers = () => {
    const roots = Array.from(document.querySelectorAll("[data-gs-lang]"));
    if (!roots.length) return;

    const closeLang = (root) => {
      root.classList.remove("is-open");
      const btn = root.querySelector(".gs-lang__trigger");
      const menu = root.querySelector(".gs-lang__menu");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (menu) menu.hidden = true;
    };

    const openLang = (root) => {
      roots.forEach((other) => {
        if (other !== root) closeLang(other);
      });
      root.classList.add("is-open");
      const btn = root.querySelector(".gs-lang__trigger");
      const menu = root.querySelector(".gs-lang__menu");
      if (btn) btn.setAttribute("aria-expanded", "true");
      if (menu) menu.hidden = false;
    };

    roots.forEach((root) => {
      const btn = root.querySelector(".gs-lang__trigger");
      if (!btn) return;

      btn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (root.classList.contains("is-open")) {
          closeLang(root);
        } else {
          openLang(root);
        }
      });
    });

    document.addEventListener("click", (event) => {
      roots.forEach((root) => {
        if (!root.contains(event.target)) {
          closeLang(root);
        }
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      roots.forEach(closeLang);
    });
  };

  initLanguageSwitchers();

  const exclusiveDetails = (selector) => {
    const items = document.querySelectorAll(selector);
    items.forEach((item) => {
      item.addEventListener("toggle", () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };

  exclusiveDetails(".gs-faq__item");

  const heroVideo = document.querySelector(".gs-hero__video");
  if (heroVideo) {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduceMotion) {
      heroVideo.removeAttribute("autoplay");
      heroVideo.pause();
    }

    const soundBtn = document.querySelector("[data-gs-hero-sound]");
    const volumeDownBtn = document.querySelector("[data-gs-hero-volume-down]");
    const volumeUpBtn = document.querySelector("[data-gs-hero-volume-up]");
    const VOLUME_STEP = 0.1;

    if (typeof heroVideo.volume === "number") {
      heroVideo.volume = Math.min(1, Math.max(0.5, heroVideo.volume || 0.8));
    }

    const syncSoundUi = () => {
      if (!soundBtn) return;
      const iconMuted = soundBtn.querySelector(".gs-hero__sound-icon--muted");
      const iconOn = soundBtn.querySelector(".gs-hero__sound-icon--on");
      const labelUnmute =
        soundBtn.getAttribute("data-label-unmute") ||
        soundBtn.getAttribute("aria-label") ||
        "Unmute video";
      const labelMute =
        soundBtn.getAttribute("data-label-mute") || "Mute video";
      const unmuted = !heroVideo.muted && heroVideo.volume > 0;
      soundBtn.setAttribute("aria-pressed", unmuted ? "true" : "false");
      soundBtn.setAttribute("aria-label", unmuted ? labelMute : labelUnmute);
      if (iconMuted) iconMuted.hidden = unmuted;
      if (iconOn) iconOn.hidden = !unmuted;
    };

    const syncVolumeUi = () => {
      const volume = heroVideo.muted ? 0 : heroVideo.volume;
      if (volumeDownBtn) {
        volumeDownBtn.disabled = volume <= 0;
      }
      if (volumeUpBtn) {
        volumeUpBtn.disabled = !heroVideo.muted && volume >= 1;
      }
    };

    const ensurePlaying = () => {
      const playPromise = heroVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    const setVolume = (next) => {
      const clamped = Math.min(1, Math.max(0, Math.round(next * 10) / 10));
      heroVideo.volume = clamped;
      heroVideo.muted = clamped === 0;
      if (!heroVideo.muted) {
        ensurePlaying();
      }
      syncSoundUi();
      syncVolumeUi();
    };

    if (soundBtn) {
      soundBtn.addEventListener("click", () => {
        if (heroVideo.muted || heroVideo.volume === 0) {
          if (heroVideo.volume === 0) {
            heroVideo.volume = 0.5;
          }
          heroVideo.muted = false;
          ensurePlaying();
        } else {
          heroVideo.muted = true;
        }
        syncSoundUi();
        syncVolumeUi();
      });
    }

    if (volumeDownBtn) {
      volumeDownBtn.addEventListener("click", () => {
        const current = heroVideo.muted ? 0 : heroVideo.volume;
        setVolume(current - VOLUME_STEP);
      });
    }

    if (volumeUpBtn) {
      volumeUpBtn.addEventListener("click", () => {
        const current = heroVideo.muted ? 0 : heroVideo.volume;
        setVolume(current + VOLUME_STEP);
      });
    }

    syncSoundUi();
    syncVolumeUi();
  }

  const initStakeholderAccordion = () => {
    const items = Array.from(document.querySelectorAll(".gs-stakeholder"));
    if (!items.length) return;

    const media = document.querySelector(".gs-stakeholders__media");
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    let mediaTimer = 0;
    let animating = false;

    const getPanel = (item) => item.querySelector(".gs-stakeholder__panel");

    const scrollToRole = (item) => {
      const stickyHeader = document.querySelector(".gs-header");
      const offset = (stickyHeader ? stickyHeader.offsetHeight : 0) + 16;
      const top =
        item.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion ? "auto" : "smooth",
      });
    };

    const pulseMedia = () => {
      if (!media || reduceMotion) return;
      media.classList.add("is-switching");
      window.clearTimeout(mediaTimer);
      mediaTimer = window.setTimeout(() => {
        media.classList.remove("is-switching");
      }, 360);
    };

    const waitForHeight = (panel) =>
      new Promise((resolve) => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          panel.removeEventListener("transitionend", onEnd);
          window.clearTimeout(timer);
          resolve();
        };
        const onEnd = (event) => {
          if (event.propertyName === "height") finish();
        };
        panel.addEventListener("transitionend", onEnd);
        const timer = window.setTimeout(finish, 420);
      });

    const expand = async (item) => {
      const panel = getPanel(item);
      if (!panel) {
        item.open = true;
        return;
      }

      item.open = true;
      item.classList.add("is-opening");

      if (reduceMotion) {
        panel.style.height = "auto";
        panel.style.opacity = "1";
        item.classList.remove("is-opening");
        return;
      }

      panel.style.height = "0px";
      panel.style.opacity = "0";
      void panel.offsetWidth;
      panel.style.height = `${panel.scrollHeight}px`;
      panel.style.opacity = "1";
      await waitForHeight(panel);
      panel.style.height = "auto";
      item.classList.remove("is-opening");
    };

    const collapse = async (item) => {
      const panel = getPanel(item);
      if (!panel || !item.open) return;

      if (reduceMotion) {
        item.open = false;
        panel.style.height = "0px";
        panel.style.opacity = "0";
        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;
      void panel.offsetWidth;
      panel.style.height = "0px";
      panel.style.opacity = "0";
      await waitForHeight(panel);
      item.open = false;
      item.classList.remove("is-opening");
    };

    items.forEach((item) => {
      item.classList.add("gs-stakeholder--ready");
      const panel = getPanel(item);
      if (!panel) return;

      if (item.open) {
        panel.style.height = "auto";
        panel.style.opacity = "1";
      } else {
        panel.style.height = "0px";
        panel.style.opacity = "0";
      }

      const summary = item.querySelector("summary");
      if (!summary) return;

      summary.addEventListener("click", async (event) => {
        event.preventDefault();
        if (animating || item.open) return;

        animating = true;
        try {
          const openItems = items.filter((other) => other.open && other !== item);
          await Promise.all(openItems.map((other) => collapse(other)));
          scrollToRole(item);
          await expand(item);
          scrollToRole(item);
          pulseMedia();
        } finally {
          animating = false;
        }
      });
    });
  };

  initStakeholderAccordion();

  const formMessages =
    window.grainsmartTheme && window.grainsmartTheme.formErrors
      ? window.grainsmartTheme.formErrors
      : {
          required: "Please fill out this field.",
          email: "Please enter an email address.",
          tel: "Please enter a telephone number.",
          acceptTerms:
            "You must accept the terms and conditions before sending your message.",
          maxLength: "Maximum %d characters allowed.",
        };

  const fieldLimits =
    window.grainsmartTheme && window.grainsmartTheme.fieldLimits
      ? window.grainsmartTheme.fieldLimits
      : {
          "full-name": 50,
          full_name: 50,
          company: 80,
          phone: 15,
          "your-email": 100,
          email: 100,
        };

  const CONTACT_FIELDS = [
    { names: ["full-name", "full_name"], required: true },
    { names: ["company"], required: true },
    { names: ["phone"], required: true, tel: true },
    { names: ["your-email", "email"], required: true, email: true },
    { names: ["message"], required: true },
    { names: ["privacy"], required: true, checkbox: true },
  ];

  const getFieldLimit = (name, control) => {
    if (fieldLimits[name]) {
      return fieldLimits[name];
    }

    const attr = control?.getAttribute("maxlength");
    return attr ? parseInt(attr, 10) : null;
  };

  const maxLengthMessage = (limit) =>
    (formMessages.maxLength || "Maximum %d characters allowed.").replace(
      "%d",
      String(limit)
    );

  const getFieldConfig = (name) =>
    CONTACT_FIELDS.find((config) => config.names.includes(name));

  const getContactForm = (node) => {
    if (!node) return null;
    if (node instanceof HTMLFormElement && node.classList.contains("gs-form")) {
      return node;
    }
    if (node.form && node.form.classList.contains("gs-form")) {
      return node.form;
    }
    return node.closest ? node.closest("form.gs-form") : null;
  };

  const getFieldControl = (form, names) => {
    for (const name of names) {
      const control = form.querySelector(`[name="${name}"]`);
      if (control) {
        return { control, name };
      }
    }
    return null;
  };

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const isValidTel = (value) => /^[\d\s\-()+]+$/.test(value);

  const validateField = ({ control, name, config }) => {
    if (config.checkbox) {
      return control.checked ? null : { name, message: formMessages.acceptTerms };
    }

    const value = control.value;
    const trimmed = value.trim();
    const maxLength = getFieldLimit(name, control);

    if (maxLength && value.length >= maxLength) {
      return { name, message: maxLengthMessage(maxLength) };
    }

    if (config.required && !trimmed) {
      return { name, message: formMessages.required };
    }

    if (config.email && trimmed && !isValidEmail(trimmed)) {
      return { name, message: formMessages.email };
    }

    if (config.tel && trimmed && !isValidTel(trimmed)) {
      return { name, message: formMessages.tel };
    }

    return null;
  };

  const validateSingleField = (form, control) => {
    if (!control || !control.name) return;

    const config = getFieldConfig(control.name);
    if (!config) return;

    const error = validateField({ control, name: control.name, config });
    if (error) {
      showFieldError(form, error.name, error.message);
      return;
    }

    clearFieldError(form, control);
  };

  const clearFieldError = (form, control) => {
    if (!control || !control.name) return;

    const name = control.name;
    form.querySelectorAll(`.gs-form__error[data-field-error="${name}"]`).forEach((tip) => {
      tip.remove();
    });

    control.classList.remove("gs-form__control--invalid");
    control.removeAttribute("aria-invalid");

    const phoneGroup = control.closest(".gs-form__phone");
    if (phoneGroup) {
      phoneGroup.classList.remove("gs-form__control--invalid");
    }

    const wrap = control.closest(".wpcf7-form-control-wrap");
    if (wrap) {
      wrap.classList.remove("gs-form__control--invalid");
    }
  };

  const clearFormErrors = (form) => {
    form.querySelectorAll(".gs-form__error, .wpcf7-not-valid-tip").forEach((tip) => tip.remove());
    form
      .querySelectorAll(".gs-form__control--invalid, .wpcf7-not-valid")
      .forEach((el) => {
        el.classList.remove("gs-form__control--invalid", "wpcf7-not-valid");
      });
    form
      .querySelectorAll('[aria-invalid="true"]')
      .forEach((el) => el.setAttribute("aria-invalid", "false"));
  };

  const showFieldError = (form, name, message) => {
    const control = form.querySelector(`[name="${name}"]`);
    if (!control) return;

    const existing = form.querySelector(`.gs-form__error[data-field-error="${name}"]`);
    if (existing) {
      existing.textContent = message;
      return;
    }

    const tip = document.createElement("span");
    tip.className = "gs-form__error";
    tip.setAttribute("role", "alert");
    tip.dataset.fieldError = name;
    tip.textContent = message;

    control.classList.add("gs-form__control--invalid");
    control.setAttribute("aria-invalid", "true");

    const phoneGroup = control.closest(".gs-form__phone");
    const wrap = control.closest(".wpcf7-form-control-wrap");
    const label = control.closest("label");

    if (phoneGroup) {
      phoneGroup.classList.add("gs-form__control--invalid");
      if (label) {
        label.appendChild(tip);
      } else {
        phoneGroup.insertAdjacentElement("afterend", tip);
      }
      return;
    }

    if (wrap) {
      wrap.classList.add("gs-form__control--invalid");
      wrap.appendChild(tip);
      return;
    }

    if (label) {
      label.appendChild(tip);
      return;
    }

    control.insertAdjacentElement("afterend", tip);
  };

  const validateContactForm = (form) => {
    const errors = [];

    CONTACT_FIELDS.forEach((config) => {
      const field = getFieldControl(form, config.names);
      if (!field) return;

      const error = validateField({ ...field, config });
      if (error) {
        errors.push(error);
      }
    });

    return errors;
  };

  const focusFirstInvalid = (form) => {
    const firstInvalid = form.querySelector(".gs-form__control--invalid, .wpcf7-not-valid");
    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const contactConfig =
    window.grainsmartTheme && window.grainsmartTheme.contact
      ? window.grainsmartTheme.contact
      : {};
  const contactApiBaseUrl = (contactConfig.apiBaseUrl || "").replace(/\/$/, "");
  const contactRequestUrl = `${contactApiBaseUrl}${
    contactConfig.requestPath || "/v1/enquiries"
  }`;
  const contactErrors = contactConfig.errors || {};
  const contactMessageKeys = contactConfig.messageKeys || {};

  /**
   * Resolve a BE error body to a user-facing message.
   * Prefer field-level messageKeys, then top-level messageKey.
   * Mapped keys show copy (may include trusted HTML); unmapped keys are shown as-is.
   * Never show HTTP codes.
   *
   * @returns {{ message: string, html: boolean }}
   */
  const resolveApiErrorMessage = (body, messageKeys = {}, fallback = "") => {
    const keysMap = messageKeys || {};
    const resolveKey = (key) => {
      if (!key || typeof key !== "string") return null;
      if (Object.prototype.hasOwnProperty.call(keysMap, key)) {
        return { message: keysMap[key], html: true };
      }
      return { message: key, html: false };
    };

    if (body && body.errors && typeof body.errors === "object") {
      for (const field of Object.keys(body.errors)) {
        const entry = body.errors[field];
        const fieldKeys = entry && entry.messageKeys;
        if (Array.isArray(fieldKeys)) {
          for (const key of fieldKeys) {
            const resolved = resolveKey(key);
            if (resolved && resolved.message) return resolved;
          }
        }
      }
    }

    if (body && body.messageKey) {
      const resolved = resolveKey(String(body.messageKey));
      if (resolved && resolved.message) return resolved;
    }

    if (body && typeof body.message === "string" && body.message.trim()) {
      return { message: body.message.trim(), html: false };
    }

    return { message: fallback || "", html: false };
  };

  const applyStatusContent = (el, message, { html = false } = {}) => {
    if (!el) return;
    if (html) {
      el.innerHTML = message;
    } else {
      el.textContent = message;
    }
  };

  const getSubmitButtons = (form) =>
    Array.from(
      form.querySelectorAll(
        ".wpcf7-submit, button[type='submit'], input[type='submit']"
      )
    );

  const keepSubmitEnabled = (form) => {
    getSubmitButtons(form).forEach((button) => {
      button.disabled = false;
      button.removeAttribute("aria-disabled");
      if (button.dataset.gsDefaultLabel) {
        button.textContent = button.dataset.gsDefaultLabel;
      }
    });
  };

  const setSubmitBusy = (form, busy) => {
    getSubmitButtons(form).forEach((button) => {
      if (!button.dataset.gsDefaultLabel) {
        button.dataset.gsDefaultLabel = button.textContent || "Send message";
      }
      button.disabled = busy;
      if (busy) {
        button.setAttribute("aria-disabled", "true");
        button.textContent = contactConfig.submitting || "Submitting…";
      } else {
        button.removeAttribute("aria-disabled");
        button.textContent = button.dataset.gsDefaultLabel;
      }
    });
  };

  const ensureContactStatus = (form) => {
    let statusEl = form.querySelector("[data-gs-contact-status]");
    if (statusEl) return statusEl;

    statusEl = document.createElement("p");
    statusEl.className = "gs-form__status";
    statusEl.setAttribute("data-gs-contact-status", "");
    statusEl.setAttribute("role", "status");
    statusEl.setAttribute("aria-live", "polite");
    statusEl.hidden = true;

    const actions = form.querySelector(".gs-form__actions, .wpcf7-submit");
    if (actions && actions.parentElement) {
      actions.parentElement.insertBefore(statusEl, actions);
    } else {
      form.appendChild(statusEl);
    }
    return statusEl;
  };

  const setContactStatus = (form, message, state, options = {}) => {
    const statusEl = ensureContactStatus(form);
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = "";
      statusEl.removeAttribute("data-state");
      return;
    }
    statusEl.hidden = false;
    applyStatusContent(statusEl, message, options);
    statusEl.setAttribute("data-state", state || "info");
  };

  const getNamedValue = (form, names) => {
    for (const name of names) {
      const control = form.querySelector(`[name="${name}"]`);
      if (control) {
        return String(control.value || "").trim();
      }
    }
    return "";
  };

  const resolvePhoneDial = (value) => {
    const raw = String(value || "").trim();
    if (!raw) return "";
    if (raw.includes(":")) {
      return raw.split(":")[1] || raw;
    }
    return raw;
  };

  const buildFullPhone = (countryValue, numberValue) => {
    const dial = resolvePhoneDial(countryValue);
    const number = String(numberValue || "").replace(/\s+/g, "");
    if (!number) return "";
    return `${dial}${number}`;
  };

  const buildEnquiryPayload = (form) => {
    const phoneCountry = getNamedValue(form, [
      "phone-country",
      "phone_country",
    ]);
    const phoneNumber = getNamedValue(form, ["phone"]);
    const phone = buildFullPhone(phoneCountry, phoneNumber);

    return {
      fullName: getNamedValue(form, ["full-name", "full_name"]),
      companyName: getNamedValue(form, ["company"]),
      phone,
      email: getNamedValue(form, ["your-email", "email"]),
      message: getNamedValue(form, ["message"]),
      language: contactConfig.language || "en",
    };
  };

  const runFormValidation = (form) => {
    clearFormErrors(form);
    setContactStatus(form, "", "");

    const errors = validateContactForm(form);
    if (!errors.length) {
      return true;
    }

    errors.forEach(({ name, message }) => {
      showFieldError(form, name, message);
    });

    focusFirstInvalid(form);
    return false;
  };

  const submitContactEnquiry = async (form) => {
    if (form.dataset.gsContactSubmitting === "1") return;

    form.dataset.gsContactSubmitting = "1";
    setSubmitBusy(form, true);
    setContactStatus(form, "", "");

    try {
      const payload = buildEnquiryPayload(form);
      const response = await fetch(contactRequestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok && response.status !== 204) {
        let detail = {
          message:
            contactErrors.generic ||
            "Something went wrong. Please try again.",
          html: false,
        };
        try {
          const body = await response.json();
          const resolved = resolveApiErrorMessage(
            body,
            contactMessageKeys,
            contactErrors.generic || ""
          );
          if (resolved.message) {
            detail = resolved;
          }
        } catch (_err) {
          // keep fallback
        }
        const error = new Error(detail.message);
        error.html = detail.html;
        throw error;
      }

      const thankYouUrl =
        window.grainsmartTheme && window.grainsmartTheme.thankYouUrl
          ? window.grainsmartTheme.thankYouUrl
          : "/thank-you/";
      window.location.assign(thankYouUrl);
    } catch (error) {
      console.error(error);
      setContactStatus(
        form,
        (error && error.message) ||
          contactErrors.generic ||
          "Something went wrong. Please try again.",
        "error",
        { html: Boolean(error && error.html) }
      );
      setSubmitBusy(form, false);
      form.dataset.gsContactSubmitting = "0";
    }
  };

  const initContactFormValidation = (form) => {
    keepSubmitEnabled(form);
    form.setAttribute("data-gs-contact-form", "");

    form.addEventListener("input", (event) => {
      validateSingleField(form, event.target);
    });

    form.addEventListener("change", (event) => {
      validateSingleField(form, event.target);
    });
  };

  const phoneCodeConfig =
    window.grainsmartTheme && window.grainsmartTheme.phoneCode
      ? window.grainsmartTheme.phoneCode
      : {};

  const initPhoneCodeSelect = (select) => {
    if (!select || select.dataset.gsPhoneCodeReady === "1") return;
    select.dataset.gsPhoneCodeReady = "1";

    const parseOption = (option) => {
      const value = option.value;
      let dial = "";
      let name = String(option.textContent || "").trim();

      if (value && value.includes(":")) {
        dial = value.split(":")[1] || "";
      }

      const match = name.match(/^(.*)\s*\(([^)]+)\)\s*$/);
      if (match) {
        name = match[1].trim();
        dial = dial || match[2].trim();
      }

      return {
        value,
        name,
        dial,
        disabled: option.disabled,
        searchText: `${name} ${dial} ${value}`.toLowerCase(),
      };
    };

    const options = Array.from(select.options)
      .map(parseOption)
      .filter((opt) => opt.value);

    const root = document.createElement("div");
    root.className = "gs-phone-code";
    root.dataset.gsPhoneCode = "";

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "gs-phone-code__trigger";
    trigger.setAttribute(
      "aria-label",
      phoneCodeConfig.openLabel ||
        select.getAttribute("aria-label") ||
        "Select country code"
    );
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");

    const dialEl = document.createElement("span");
    dialEl.className = "gs-phone-code__dial";

    const chevron = document.createElement("span");
    chevron.className = "gs-phone-code__chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    trigger.appendChild(dialEl);
    trigger.appendChild(chevron);

    const panel = document.createElement("div");
    panel.className = "gs-phone-code__panel";
    panel.hidden = true;

    const search = document.createElement("input");
    search.type = "search";
    search.className = "gs-phone-code__search";
    search.placeholder =
      phoneCodeConfig.searchPlaceholder || "Search country or code…";
    search.setAttribute("autocomplete", "off");
    search.setAttribute("aria-label", search.placeholder);

    const list = document.createElement("ul");
    list.className = "gs-phone-code__list";
    list.setAttribute("role", "listbox");

    const empty = document.createElement("p");
    empty.className = "gs-phone-code__empty";
    empty.hidden = true;
    empty.textContent = phoneCodeConfig.noResults || "No countries found";

    panel.appendChild(search);
    panel.appendChild(list);
    panel.appendChild(empty);
    root.appendChild(trigger);
    root.appendChild(panel);

    select.classList.add("gs-form__phone-code--enhanced");
    select.setAttribute("tabindex", "-1");
    select.setAttribute("aria-hidden", "true");
    select.insertAdjacentElement("afterend", root);

    const getSelected = () =>
      options.find((opt) => opt.value === select.value) || options[0] || null;

    const syncTriggerLabel = () => {
      const selected = getSelected();
      dialEl.textContent = selected ? selected.dial || selected.name : "+";
      trigger.title = selected
        ? `${selected.name} (${selected.dial})`
        : trigger.getAttribute("aria-label") || "";
    };

    const closePanel = () => {
      panel.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      root.classList.remove("is-open");
      panel.style.top = "";
      panel.style.left = "";
      panel.style.width = "";
    };

    const positionPanel = () => {
      const rect = trigger.getBoundingClientRect();
      const width = Math.min(340, Math.max(280, window.innerWidth - 32));
      let left = rect.left;
      if (left + width > window.innerWidth - 16) {
        left = Math.max(16, window.innerWidth - width - 16);
      }
      const below = rect.bottom + 8;
      const estimatedHeight = 320;
      const top =
        below + estimatedHeight > window.innerHeight - 16 &&
        rect.top > estimatedHeight
          ? Math.max(16, rect.top - estimatedHeight - 8)
          : below;
      panel.style.top = `${top}px`;
      panel.style.left = `${left}px`;
      panel.style.width = `${width}px`;
    };

    const openPanel = () => {
      panel.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      root.classList.add("is-open");
      search.value = "";
      renderList("");
      positionPanel();
      window.setTimeout(() => {
        search.focus();
        const selectedItem = list.querySelector(".is-selected");
        if (selectedItem) {
          selectedItem.scrollIntoView({ block: "nearest" });
        }
      }, 0);
    };

    const selectValue = (value) => {
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        select.dispatchEvent(new Event("input", { bubbles: true }));
      }
      syncTriggerLabel();
      closePanel();
      trigger.focus();
    };

    const renderList = (query) => {
      const needle = String(query || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
      list.innerHTML = "";
      let visible = 0;

      options.forEach((opt) => {
        if (opt.disabled) return;
        if (needle && !opt.searchText.includes(needle)) return;

        visible += 1;
        const item = document.createElement("li");
        item.className = "gs-phone-code__option";
        item.setAttribute("role", "option");
        item.dataset.value = opt.value;

        const nameEl = document.createElement("span");
        nameEl.className = "gs-phone-code__name";
        nameEl.textContent = opt.name;

        const codeEl = document.createElement("span");
        codeEl.className = "gs-phone-code__code";
        codeEl.textContent = opt.dial;

        item.appendChild(nameEl);
        item.appendChild(codeEl);

        if (opt.value === select.value) {
          item.classList.add("is-selected");
          item.setAttribute("aria-selected", "true");
        }

        item.addEventListener("click", () => selectValue(opt.value));
        list.appendChild(item);
      });

      empty.hidden = visible > 0;
    };

    trigger.addEventListener("click", () => {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    search.addEventListener("input", () => {
      renderList(search.value);
    });

    search.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closePanel();
        trigger.focus();
      }
      if (event.key === "Enter") {
        const first = list.querySelector(".gs-phone-code__option");
        if (first) {
          event.preventDefault();
          selectValue(first.dataset.value);
        }
      }
    });

    document.addEventListener("click", (event) => {
      if (!root.contains(event.target) && !panel.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !panel.hidden) {
        closePanel();
      }
    });

    window.addEventListener(
      "resize",
      () => {
        if (!panel.hidden) positionPanel();
      },
      { passive: true }
    );

    document.addEventListener(
      "scroll",
      () => {
        if (!panel.hidden) positionPanel();
      },
      true
    );

    syncTriggerLabel();
  };

  const initPhoneCodeSelects = () => {
    document
      .querySelectorAll("select.gs-form__phone-code")
      .forEach(initPhoneCodeSelect);
  };

  const initContactForms = () => {
    document.querySelectorAll("form.gs-form").forEach(initContactFormValidation);
    initPhoneCodeSelects();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactForms);
  } else {
    initContactForms();
  }

  document.addEventListener(
    "click",
    (event) => {
      const submitter = event.target.closest(
        "form.gs-form input[type='submit'], form.gs-form button[type='submit']"
      );
      if (!submitter) return;

      const form = getContactForm(submitter);
      if (!form) return;

      if (runFormValidation(form)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = getContactForm(event.target);
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!runFormValidation(form)) {
        return;
      }

      submitContactEnquiry(form);
    },
    true
  );

  const initGetStartedModal = () => {
    const modal = document.querySelector("[data-gs-get-started-modal]");
    const form = document.querySelector("[data-gs-get-started-form]");
    if (!modal || !form || typeof modal.showModal !== "function") {
      return null;
    }

    const theme = window.grainsmartTheme || {};
    const config = theme.getStarted || {};
    const errors = config.errors || {};
    const messageKeys = config.messageKeys || {};
    const apiBaseUrl = (config.apiBaseUrl || "").replace(/\/$/, "");
    const requestUrl = `${apiBaseUrl}${
      config.requestPath || "/v1/subscription-requests"
    }`;
    const productsUrl = `${apiBaseUrl}${
      config.productsPath || "/v1/subscription-products"
    }`;
    const subtitleEl = modal.querySelector("[data-gs-get-started-subtitle]");
    const planInput = form.querySelector("[data-gs-get-started-plan]");
    const customerTypeInput = form.querySelector(
      "[data-gs-get-started-customer-type]"
    );
    const businessTypeSelect = form.querySelector(
      "[data-gs-get-started-business-type]"
    );
    const statusEl = form.querySelector("[data-gs-get-started-status]");
    const submitBtn = form.querySelector("[data-gs-get-started-submit]");
    // Temporary prod kill-switch: keep Get Started / Free Trial submit disabled.
    const submissionsDisabled = true;
    const closeButtons = modal.querySelectorAll("[data-gs-get-started-close]");
    const paymentField = form.querySelector("[data-gs-get-started-payment]");
    const poField = form.querySelector("[data-gs-get-started-po-field]");
    const poInput = form.querySelector("[data-gs-get-started-po-input]");
    const recurringField = form.querySelector(
      "[data-gs-get-started-recurring]"
    );
    const recurringInputs = Array.from(
      form.querySelectorAll('input[name="recurring"]')
    );
    const paymentInputs = Array.from(
      form.querySelectorAll('input[name="preferredPaymentMethod"]')
    );
    const submitDefaultLabel = submitBtn ? submitBtn.textContent : "Submit";
    let productIdsByPlan = null;
    let productsPromise = null;
    let formMode = "get-started";

    const clearFieldErrors = () => {
      form.querySelectorAll(".gs-modal__field.is-invalid").forEach((field) => {
        field.classList.remove("is-invalid");
        const error = field.querySelector(".gs-modal__error");
        if (error) error.remove();
      });
    };

    const setStatus = (message, state, options = {}) => {
      if (!statusEl) return;
      if (!message) {
        statusEl.hidden = true;
        statusEl.textContent = "";
        statusEl.removeAttribute("data-state");
        return;
      }
      statusEl.hidden = false;
      applyStatusContent(statusEl, message, options);
      statusEl.setAttribute("data-state", state || "info");
    };

    const showFieldError = (field, message) => {
      if (!field) return;
      field.classList.add("is-invalid");
      let error = field.querySelector(".gs-modal__error");
      if (!error) {
        error = document.createElement("p");
        error.className = "gs-modal__error";
        field.appendChild(error);
      }
      error.textContent = message;
    };

    const syncPoField = () => {
      if (formMode === "free-trial") {
        if (poField) poField.hidden = true;
        if (poInput) {
          poInput.value = "";
          poInput.required = false;
        }
        return;
      }
      const selected = paymentInputs.find((input) => input.checked);
      const isPo = selected && selected.value === "PURCHASE_ORDER";
      if (poField) {
        poField.hidden = !isPo;
        if (!isPo) {
          poField.classList.remove("is-invalid");
          const error = poField.querySelector(".gs-modal__error");
          if (error) error.remove();
        }
      }
      if (poInput) {
        poInput.required = Boolean(isPo);
        if (!isPo) {
          poInput.value = "";
        }
      }
    };

    const syncFormModeFields = () => {
      const isFreeTrial = formMode === "free-trial";
      if (recurringField) {
        recurringField.hidden = isFreeTrial;
      }
      if (paymentField) {
        paymentField.hidden = isFreeTrial;
      }
      if (isFreeTrial) {
        recurringInputs.forEach((input) => {
          input.checked = input.value === "MONTHLY";
        });
        paymentInputs.forEach((input) => {
          input.checked = input.value === "CREDIT_CARD";
        });
      }
      syncPoField();
    };

    const validateForm = () => {
      clearFieldErrors();
      let valid = true;
      const requiredMsg = errors.required || "Please fill out this field.";
      const emailMsg = errors.email || "Please enter a valid email address.";

      form.querySelectorAll("[required]").forEach((input) => {
        if (input.disabled || input.closest("[hidden]")) return;
        const field = input.closest(".gs-modal__field");
        const value = String(input.value || "").trim();
        if (!value) {
          valid = false;
          showFieldError(field, requiredMsg);
          return;
        }
        if (input.type === "email") {
          const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          if (!ok) {
            valid = false;
            showFieldError(field, emailMsg);
          }
        }
      });

      // Purchase Order requires a PO Number even if the attribute was missed.
      if (formMode !== "free-trial") {
        const selectedPayment = paymentInputs.find((input) => input.checked);
        if (
          selectedPayment &&
          selectedPayment.value === "PURCHASE_ORDER" &&
          poInput &&
          poField &&
          !poField.hidden
        ) {
          const poValue = String(poInput.value || "").trim();
          if (!poValue) {
            valid = false;
            showFieldError(poField, requiredMsg);
          }
        }
      }

      return valid;
    };

    const loadProducts = async () => {
      if (productIdsByPlan) return productIdsByPlan;
      if (productsPromise) return productsPromise;

      productsPromise = fetch(productsUrl, {
        method: "GET",
        headers: { Accept: "application/json" },
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`Products request failed: ${response.status}`);
          }
          const products = await response.json();
          const map = {};
          (Array.isArray(products) ? products : []).forEach((product) => {
            if (!product || !product.id) return;
            if (product.plan) {
              map[String(product.plan).toUpperCase()] = product.id;
            }
            if (product.name) {
              const nameKey = String(product.name)
                .trim()
                .toUpperCase()
                .replace(/\s+PACK$/, "");
              if (nameKey) {
                map[nameKey] = product.id;
              }
            }
          });
          productIdsByPlan = map;
          return map;
        })
        .catch((error) => {
          productsPromise = null;
          throw error;
        });

      return productsPromise;
    };

    const resolveBillingProductId = async (planId) => {
      const map = await loadProducts();
      const key = String(planId || "value").toUpperCase();
      return map[key] || map.VALUE || "";
    };

    const buildPayload = async () => {
      const data = new FormData(form);
      const planId = String(data.get("plan") || "value");
      const billingProductId = await resolveBillingProductId(planId);
      if (!billingProductId) {
        throw new Error("MISSING_BILLING_PRODUCT");
      }

      const isFreeTrial = formMode === "free-trial";
      const payload = {
        type: isFreeTrial ? "FREE_TRIAL" : config.requestType || "SUBSCRIPTION",
        billingProductId,
        country: String(data.get("country") || "").trim(),
        businessType: String(data.get("businessType") || "").trim(),
        clientName: String(data.get("clientName") || "").trim(),
        contactPerson: String(data.get("contactPerson") || "").trim(),
        email: String(data.get("email") || "").trim(),
        preferredPaymentMethod: isFreeTrial
          ? "CREDIT_CARD"
          : String(
              data.get("preferredPaymentMethod") || "CREDIT_CARD"
            ).trim(),
        recurring: String(data.get("recurring") || "MONTHLY").trim(),
        language: config.language || "en",
      };

      // Free Trial: API validates capacity as number even when omitted.
      if (isFreeTrial) {
        payload.capacity = 0;
      }

      const businessNumber = String(data.get("businessNumber") || "").trim();
      const phone = buildFullPhone(
        data.get("phone_country"),
        data.get("phone")
      );
      const address = String(data.get("address") || "").trim();
      const notes = String(data.get("notes") || "").trim();
      const poNumber = String(data.get("poNumber") || "").trim();

      if (businessNumber) payload.businessNumber = businessNumber;
      if (phone) payload.phone = phone;
      if (address) payload.address = address;
      if (notes) payload.notes = notes;
      if (
        !isFreeTrial &&
        payload.preferredPaymentMethod === "PURCHASE_ORDER" &&
        poNumber
      ) {
        payload.poNumber = poNumber;
      }

      return payload;
    };

    const closeModal = () => {
      if (modal.open) {
        modal.close();
      }
      document.body.classList.remove("gs-modal-open");
    };

    const syncBusinessTypeOptions = (customerType) => {
      if (!businessTypeSelect) return;

      // Free Trial keeps all business types; Get Started filters by subscription tab.
      const filterByCustomer = formMode !== "free-trial";
      const isMill = customerType === "mill";
      const options = Array.from(businessTypeSelect.options);

      options.forEach((option) => {
        if (option.dataset.gsBusinessPlaceholder !== undefined) {
          option.hidden = filterByCustomer && isMill;
          option.disabled = true;
          return;
        }

        if (!filterByCustomer) {
          option.hidden = false;
          option.disabled = false;
          return;
        }

        const group = option.getAttribute("data-gs-customer-group") || "other";
        const allowed = isMill ? group === "mill" : group === "other";
        option.hidden = !allowed;
        option.disabled = !allowed;
      });

      if (!filterByCustomer) {
        const selected = businessTypeSelect.selectedOptions[0];
        if (selected && selected.disabled) {
          businessTypeSelect.value = "";
        }
        return;
      }

      if (isMill) {
        businessTypeSelect.value = "MILL";
      } else {
        const selected = businessTypeSelect.selectedOptions[0];
        const selectedGroup = selected
          ? selected.getAttribute("data-gs-customer-group")
          : "";
        if (!selected || selectedGroup !== "other") {
          businessTypeSelect.value = "";
        }
      }
    };

    const openModal = ({ planId, customerType, subtitle, mode }) => {
      formMode = mode === "free-trial" ? "free-trial" : "get-started";
      const resolvedCustomerType = customerType || "mill";
      if (planInput) planInput.value = planId || "value";
      if (customerTypeInput) {
        customerTypeInput.value = resolvedCustomerType;
      }
      if (subtitleEl) {
        if (formMode === "free-trial") {
          subtitleEl.hidden = true;
          subtitleEl.textContent = "";
        } else {
          subtitleEl.hidden = false;
          if (subtitle) {
            subtitleEl.textContent = subtitle;
          }
        }
      }
      syncBusinessTypeOptions(resolvedCustomerType);

      clearFieldErrors();
      setStatus("", "");
      syncFormModeFields();
      if (submitBtn) {
        submitBtn.disabled = submissionsDisabled;
        submitBtn.setAttribute("aria-disabled", submissionsDisabled ? "true" : "false");
        submitBtn.textContent = submitDefaultLabel;
      }

      loadProducts().catch(() => {});

      if (!modal.open) {
        modal.showModal();
      }
      document.body.classList.add("gs-modal-open");

      const firstField = form.querySelector(
        "select[name='country'], input:not([type='hidden'])"
      );
      if (firstField) {
        window.setTimeout(() => firstField.focus(), 30);
      }
    };

    paymentInputs.forEach((input) => {
      input.addEventListener("change", syncPoField);
    });
    syncFormModeFields();

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });

    modal.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeModal();
    });

    let backdropPointerDown = false;
    const isBackdropTarget = (target) =>
      target === modal ||
      (target instanceof Element && !target.closest(".gs-modal__panel"));

    modal.addEventListener("pointerdown", (event) => {
      backdropPointerDown = isBackdropTarget(event.target);
    });

    modal.addEventListener("click", (event) => {
      if (backdropPointerDown && isBackdropTarget(event.target)) {
        closeModal();
      }
      backdropPointerDown = false;
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (submissionsDisabled) return;
      if (!validateForm()) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = config.submitting || "Submitting…";
      }
      setStatus("", "");

      try {
        const payload = await buildPayload();
        const response = await fetch(requestUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok && response.status !== 204) {
          let detail = {
            message:
              errors.generic || "Something went wrong. Please try again.",
            html: false,
          };
          try {
            const body = await response.json();
            const resolved = resolveApiErrorMessage(
              body,
              messageKeys,
              errors.generic || ""
            );
            if (resolved.message) {
              detail = resolved;
            }
          } catch (_err) {
            // keep fallback
          }
          const error = new Error(detail.message);
          error.html = detail.html;
          throw error;
        }

        setStatus(
          config.success || "Thanks — your request has been received.",
          "success"
        );

        const requestSentBase =
          theme.requestSentUrl ||
          new URL("request-sent/", window.location.href).href;
        const requestSentUrl = new URL(
          requestSentBase,
          window.location.origin
        );
        if (payload.email) {
          requestSentUrl.searchParams.set("email", payload.email);
        }
        window.setTimeout(() => {
          window.location.assign(requestSentUrl.toString());
        }, 600);
      } catch (error) {
        console.error(error);
        const message =
          error && error.message === "MISSING_BILLING_PRODUCT"
            ? errors.product ||
              "Unable to load subscription plans. Please try again."
            : (error && error.message) ||
              errors.generic ||
              "Something went wrong. Please try again.";
        setStatus(message, "error", {
          html:
            Boolean(error && error.html) &&
            error.message !== "MISSING_BILLING_PRODUCT",
        });
        if (submitBtn) {
          submitBtn.disabled = submissionsDisabled ? true : false;
          submitBtn.setAttribute(
            "aria-disabled",
            submissionsDisabled ? "true" : "false"
          );
          submitBtn.textContent = submitDefaultLabel;
        }
      }
    });

    return { openModal, closeModal };
  };

  const packLabel = (planId, packs = {}) => {
    if (packs[planId]) return packs[planId];
    if (planId === "premium") return "Premium Pack";
    if (planId === "enterprise") return "Enterprise Pack";
    return "Value Pack";
  };

  let getStartedModalApi = null;

  const ensureGetStartedModal = () => {
    if (!getStartedModalApi) {
      getStartedModalApi = initGetStartedModal();
    }
    return getStartedModalApi;
  };

  document.addEventListener(
    "click",
    (event) => {
      const trigger = event.target.closest("[data-gs-get-started-open]");
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      const modalApi = ensureGetStartedModal();
      if (!modalApi) return;

      const theme = window.grainsmartTheme || {};
      const packs = (theme.subscription && theme.subscription.packs) || {};
      const planId = trigger.getAttribute("data-plan-id") || "value";
      const customerType =
        trigger.getAttribute("data-customer-type") || "mill";
      const mode =
        trigger.getAttribute("data-gs-form-mode") || "get-started";

      modalApi.openModal({
        planId,
        customerType,
        mode,
        subtitle: packLabel(planId, packs),
      });
    },
    true
  );

  const initSubscriptionSection = (getStartedModal) => {
    const root = document.querySelector("[data-gs-subscription]");
    if (!root) return;

    const theme = window.grainsmartTheme || {};
    const subscription = theme.subscription || {};
    const packs = subscription.packs || {};

    const typeInputs = Array.from(
      root.querySelectorAll("[data-gs-customer-type]")
    );
    const plans = Array.from(root.querySelectorAll("[data-gs-plan]"));

    let selectedPlan = "value";

    const getCustomerType = () => {
      const checked = typeInputs.find((input) => input.checked);
      return checked ? checked.value : "mill";
    };

    const setCtaStyle = (cta, isPrimary) => {
      if (!cta) return;
      cta.classList.toggle("gs-btn--primary", isPrimary);
      cta.classList.toggle("gs-btn--muted", !isPrimary);
    };

    const setPlanState = () => {
      const customerType = getCustomerType();
      const isMill = customerType === "mill";

      if (!isMill) {
        selectedPlan = "value";
      }

      plans.forEach((planEl) => {
        const planId = planEl.getAttribute("data-plan-id") || "";
        const cta = planEl.querySelector("[data-gs-plan-cta]");
        const unavailable = planEl.querySelector("[data-gs-plan-unavailable]");
        const available = isMill || planId === "value";
        const isSelected = available && planId === selectedPlan;

        planEl.classList.toggle("is-disabled", !available);
        planEl.classList.toggle("is-selected", isSelected);
        planEl.setAttribute("aria-disabled", available ? "false" : "true");
        planEl.tabIndex = available ? 0 : -1;

        if (cta) {
          // Importer/Grower: hide CTA for non-Value plans.
          cta.hidden = !available;
          // Temporary: Mill Enterprise Get Started stays visible but disabled.
          const ctaDisabled = available && planId === "enterprise";
          cta.disabled = ctaDisabled;
          // Mill: Value/Premium CTAs stay green. Importer tab: only Value is shown.
          setCtaStyle(cta, available && !ctaDisabled && (isMill || isSelected));
          if (available && !ctaDisabled) {
            cta.removeAttribute("aria-disabled");
            cta.removeAttribute("tabindex");
          } else {
            cta.setAttribute("aria-disabled", "true");
            cta.setAttribute("tabindex", "-1");
          }
        }

        if (unavailable) {
          unavailable.hidden = available;
        }
      });
    };

    const selectPlan = (planId) => {
      const customerType = getCustomerType();
      if (customerType !== "mill" && planId !== "value") return;

      selectedPlan = planId;
      setPlanState();
    };

    const openGetStarted = (planId) => {
      // Temporary: Enterprise signup CTA disabled.
      if (planId === "enterprise") return;

      const customerType = getCustomerType();
      selectPlan(planId);
      if (!getStartedModal) return;
      getStartedModal.openModal({
        planId,
        customerType,
        subtitle: packLabel(planId, packs),
      });
    };

    typeInputs.forEach((input) => {
      input.addEventListener("change", setPlanState);
    });

    plans.forEach((planEl) => {
      const planId = planEl.getAttribute("data-plan-id") || "";

      planEl.addEventListener("click", (event) => {
        if (planEl.classList.contains("is-disabled")) {
          event.preventDefault();
          return;
        }

        const cta = event.target.closest("[data-gs-plan-cta]");
        if (cta) {
          event.preventDefault();
          if (cta.disabled || cta.getAttribute("aria-disabled") === "true") {
            return;
          }
          openGetStarted(planId);
          return;
        }

        selectPlan(planId);
      });

      planEl.addEventListener("keydown", (event) => {
        if (planEl.classList.contains("is-disabled")) return;
        if (event.key !== "Enter" && event.key !== " ") return;
        if (event.target.closest("[data-gs-plan-cta]")) return;
        event.preventDefault();
        selectPlan(planId);
      });
    });

    setPlanState();
  };

  const initPricingAndGetStarted = () => {
    initSubscriptionSection(ensureGetStartedModal());
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPricingAndGetStarted);
  } else {
    initPricingAndGetStarted();
  }
})();
